var r = {};
export {
  r as __exports
};
//# sourceMappingURL=index.es271.js.map
